import { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const ShuffleIcon: FC<IconProps> = ({
  width = 23,
  height = 23,
  stroke = '#111026',
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.5 6.52622C9.75718 5.03554 10.564 3.69549 11.7611 2.77072C12.9582 1.84595 14.4586 1.40371 15.9659 1.53132C17.4732 1.65894 18.8779 2.34715 19.9025 3.46002C20.9271 4.57289 21.4971 6.02952 21.5 7.54222C21.4998 8.96872 20.9951 10.3492 20.0751 11.4394C19.1551 12.5295 17.8792 13.2592 16.473 13.4992M1.5 8.49922C1.5 5.18222 4.183 2.49922 7.5 2.49922L6.643 4.21322M21.5 14.4992C21.5 17.8162 18.817 20.4992 15.5 20.4992L16.357 18.7852M7.5 21.4992C9.0913 21.4992 10.6174 20.8671 11.7426 19.7419C12.8679 18.6166 13.5 17.0905 13.5 15.4992C13.5 13.9079 12.8679 12.3818 11.7426 11.2566C10.6174 10.1314 9.0913 9.49922 7.5 9.49922C5.9087 9.49922 4.38258 10.1314 3.25736 11.2566C2.13214 12.3818 1.5 13.9079 1.5 15.4992C1.5 17.0905 2.13214 18.6166 3.25736 19.7419C4.38258 20.8671 5.9087 21.4992 7.5 21.4992Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
